import React from 'react'
import { useSelector } from 'react-redux'

import Pagination from '@/compoments/common/Pagination'
import {
    selectNotifications,
    selectPagination,
} from '@/features/notifications/notificationsSlice'
import type { INotification } from '@/types/notifications'

import { NotificationHeader } from './components/NotificationHeader'
import { NotificationItem } from './components/NotificationItem'

const NotificationManagerPage = () => {
    const notification = useSelector(selectNotifications)
    const pagination = useSelector(selectPagination)

    return (
        <>
            <main className="content flex flex-col">
                <div className="px-container flex flex-col flex-auto">
                    <div className="table-group">
                        <NotificationHeader />
                        <div className="table-body table-responsive p-0">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Event</th>
                                        <th>Scheduled</th>
                                        <th>Roles</th>
                                        <th style={{ width: 10 }}>Status</th>
                                        <th style={{ width: 10 }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {notification?.map(
                                        (notification: INotification) => (
                                            <NotificationItem
                                                key={notification.id}
                                                notification={notification}
                                            />
                                        ),
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Pagination
                        pagination={pagination?.pagination}
                        onPageChange={() => {}}
                    />
                </div>
            </main>
        </>
    )
}

export default NotificationManagerPage
